import React, { Component } from "react"

import { adminOperators } from "../api/Operator"
import { getAdmin } from "../api/Admin"

/* JWT */
import { isExpired } from "react-jwt"

/* Redux */
import { connect } from "react-redux"

/* Lottie */
import Lottie from "lottie-react"

/* Lottie File */
const LOADONG = require("../constants/mainloading.json")


class MainLoading extends Component {

    componentDidUpdate = () => {

        const { token, loading, setOperators, setLoading, setAdmin } = this.props

        /* Ждём только когда включена загрузка и нет уже идущего запроса */
        if (!loading || this._fetching) return

        this._fetching = true

        /* Токен отсутствует или протух → снимаем загрузку и уводим на логин */
        if (!token || isExpired(token)) {
            localStorage.removeItem("token")
            this._fetching = false
            setLoading(false)
            window.location.href = "/"
            return
        }

        Promise.all([adminOperators(token), getAdmin(token)])
            .then(([operatorsResponse, adminResponse]) => {

                /* Сервер отклонил токен → на логин */
                if (!operatorsResponse || [401, 403, 498].includes(operatorsResponse.status)) {
                    localStorage.removeItem("token")
                    window.location.href = "/"
                    return
                }

                if (operatorsResponse.status === 200) {
                    const list = operatorsResponse.data.map((operator) => ({ ...operator, checked: true }))
                    setOperators(list)
                }

                if (adminResponse && adminResponse.status === 200) {
                    setAdmin(adminResponse.data)
                }
            })
            .catch(() => {
                /* Сеть недоступна — просто снимем загрузку в finally */
            })
            .finally(() => {
                this._fetching = false
                setLoading(false)
            })

    }


    render = () => {

        const { loading, children } = this.props

        if (loading) {
            return (
                <div className="main-loading">
                    <Lottie animationData={LOADONG} loop={true} />
                </div>
            )
        }

        return children

    }

}


const mapStateToProps = (state) => {
    return {
        loading: state.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOperators: (data) => dispatch({ type: "SET_OPERATORS", payload: data }),
        setAdmin: (data) => dispatch({ type: "SET_ADMIN", payload: data }),
        setLoading: (data) => dispatch({ type: "SET_LOADING", payload: data }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLoading)